import React, { useState } from "react";
import { Button } from "antd";
import { useMediaQuery } from "react-responsive";
import EmployeesSearch from "./EmployeesSearch";
import EmployeeWage from "./EmployeeWage";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import SearchFilters from "./SearchFilters";
import { FormattedMessage } from "react-intl";
import Walkthrough from "./Walkthrough";

const Matching = (props) => {
  const {
    activeEvent,
    onChangeSlide,
    onChosenEmployee,
    onRemoveEmployee,
    onTariffChanged,
    onUseEmployeeTariffChanged,
    onTransportationChanged,
    onOncallChange,
    submitEvent,
    type,
    orders,
    originalEmployeeId,
    patient,
  } = props;
  const initial = {
    distance: 0,
    classification: 0,
  };
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1500px)",
  });

  const intl = useIntl();
  const [distance, setDistance] = useState(initial["distance"]);
  const [classification, setClassification] = useState(
    initial["classification"]
  );
  const [total, setTotal] = useState(initial["total"]);
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const createLoading = useSelector(
    (state) => state.pendingActions["scheduling/create"]
  );

  const editLoading = useSelector(
    (state) => state.pendingActions["scheduling/edit"]
  );

  const onDistanceChange = (val) => {
    setDistance(val);
  };
  const onClassificatinChange = (val) => {
    setClassification(val);
  };
  const onTotalChange = (val) => {
    setTotal(val);
  };
  const onResetFilters = (val) => {
    const initial = {
      distance: 0,
      classification: 0,
    };

    setDistance(initial["distance"]);
    setClassification(initial["classification"]);
  };

  return (
    <div className="matching-slide">
      <div>
        <SearchFilters
          onDistanceChange={onDistanceChange}
          onClassificatinChange={onClassificatinChange}
          onTotalChange={onTotalChange}
          onResetFilters={onResetFilters}
          distance={distance}
          classification={classification}
          patient={patient}
        />
        <EmployeeWage
          type={type}
          activeEvent={activeEvent}
          onTariffChanged={onTariffChanged}
          onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
          onTransportationChanged={onTransportationChanged}
          onOncallChange={onOncallChange}
        />
      </div>
      <div className="matching">
        <div className="main">
          <EmployeesSearch
            activeEvent={activeEvent}
            onChosenEmployee={onChosenEmployee}
            onRemoveEmployee={onRemoveEmployee}
            distanceFilter={distance}
            classificationFilter={classification}
            totalFilter={total}
            type={type}
            originalEmployeeId={originalEmployeeId}
            patient={patient}
          />
        </div>
        <div className="actions">
          <Button
            style={{ minWidth: "135px" }}
            onClick={() => onChangeSlide(0)}
            icon={
              currentAppLocale.direction === "rtl" ? (
                <ArrowRightOutlined />
              ) : (
                <ArrowLeftOutlined />
              )
            }
          >
            {intl.formatMessage({
              id: "app.actions.back",
            })}
          </Button>
          <div style={{ width: "10px" }} />
          <Button
            type="primary"
            onClick={submitEvent}
            style={{ minWidth: "135px" }}
            disabled={
              (activeEvent &&
                ((!activeEvent.tariff_id && !activeEvent.use_employee_tariff) ||
                  !activeEvent.employee_id)) ||
              createLoading ||
              editLoading
            }
          >
            {<FormattedMessage id="app.actions.finish" />}
          </Button>
        </div>
      </div>
      {isDesktopOrLaptop && (
        <Walkthrough activeEvent={activeEvent} orders={orders} type={type} />
      )}
    </div>
  );
};

export default Matching;
